import { MailboxInfo } from 'owa-client-ids';
import { addPopoutV2, getReadingPaneRouteForPopoutV2 } from 'owa-popout-v2';
import ReadingPanePopoutItemFolderInfo from '../schema/ReadingPanePopoutItemFolderInfo';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    BohemiaOptions,
} from 'owa-outlook-service-options';

/**
 * Popout reading pane based on either itemId or InternetMessageId
 */
export default function popoutReadingPane(
    itemId?: string,
    internetMessageId?: string,
    mailboxInfo?: MailboxInfo,
    folderInfo?: ReadingPanePopoutItemFolderInfo
) {
    const route = getReadingPaneRouteForPopoutV2(
        mailboxInfo,
        itemId,
        null /*conversationId*/,
        internetMessageId
    );

    // Because Bohemia relies on a SDS option to load,
    // We need to pass this value to the popout, since
    // OWA will not have completed this call in time.
    // This pattern should not be repeated.
    const readingPanePopoutData = {
        ...folderInfo,
        includeBohemiaOnPopout:
            getOptionsForFeature<BohemiaOptions>(OwsOptionsFeatureType.Bohemia).bohemiaEnabled &&
            isFeatureEnabled('rp-prague'),
    };

    addPopoutV2('mail', route, readingPanePopoutData, {
        resizable: true,
    });
}
